<template>
	<b-modal id="report-modal" title="Bill Audit Report" :no-close-on-backdrop="true" hide-footer>
		<b-form @submit="onSubmit" ref="form" novalidate class="needs-validation">
			<b-row>
				<b-col>
					<b-form-group label="Sito">
						<b-form-select required v-model="siteId" :options="sites" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Punto di prelievo">
						<b-form-select required :disabled="!siteId" v-model="supplyChannelCode"
							:options="supplyChannels" />
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Autoproduzione">
						<b-form-select :disabled="!siteId" v-model="selfProductionChannelCode"
							:options="selfProductionChannels" />
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Opzione tariffaria">
						<b-form-input required v-model="tariffOption" />
					</b-form-group>
				</b-col>
				<b-col><b-form-group label="Classe">
						<b-form-input required v-model="className" />
					</b-form-group></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Fornitore">
						<b-form-input required v-model="supplier" />
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="POD">
						<b-form-input required v-model="pod" />
					</b-form-group>
				</b-col>

			</b-row>
			<b-form-group>
				<b-row>
					<b-col>
						<span class="d-block">Anno</span>
						<b-form-input v-model="year" type="number" required />
					</b-col>
					<b-col>
					</b-col>
				</b-row>
			</b-form-group>
			<b-row>
				<b-col class="d-flex justify-content-end">
					<b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('report-modal')">Annulla</b-btn>
					<b-btn type="submit" variant="primary">Salva</b-btn>
				</b-col>
			</b-row>
		</b-form>
	</b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'

export default {
	name: "BillAuditModal",
	components: { VueMonthlyPicker },
	data() {
		return {
			id: null,
			siteId: null,
			supplyChannelCode: null,
			selfProductionChannelCode: null,
			supplier: null,
			pod: null,
			year: null,
			className: null,
			tariffOption: null,
			errorFrom: false,
			errorTo: false,
		}
	},
	created() {
		if (this.userSites.length == 1) {
			this.siteId = this.userSites[0].id
		}
	},
	methods: {
		setData(report) {
			Object.keys(report).forEach(key => {
				this[key] = report[key]
			})
			console.log(report.from)
			this.year = report.from.toString().slice(0, 4)
		},
		async onSubmit(e) {
			e.preventDefault()
			if (!this.$refs.form.checkValidity()) {
				this.$refs.form.classList.add('was-validated');
				return;
			}

			const data = {
				id: this.id,
				className: this.className,
				tariffOption: this.tariffOption,
				supplier: this.supplier,
				pod: this.pod,
				siteId: this.siteId,
				from: parseInt(this.year + '01'),
				to: parseInt(this.year + '12'),
				supplyChannelCode: this.supplyChannelCode,
				selfProductionChannelCode: this.selfProductionChannelCode
			}

			this.$store.commit("loading")
			this.$bvModal.hide('report-modal')

			const action = data.id ? 'update' : 'create'
			const result = await this.$store.dispatch(`billaudit/${action}`, data)
			this.$store.commit("stopLoading");

			if (result.code < 0) {
				this.$notify({
					type: "error",
					text: result.message,
					title: 'Errore',
				});
			} else {
				this.$notify({
					type: "success",
					text: "Report creato correttamente",
					title: 'Conferma',
				});
				this.$emit("created")
			}
		}
	},
	computed: {
		...mapGetters(['userSites']),
		monthLabels() {
			return this.$store.state.utils.monthsShort;
		},
		sites() {
			return this.userSites.map(site => {
				return {
					value: site.id,
					text: site.name
				}
			})
		},
		channels() {
			if (!this.siteId) {
				return []
			}
			return this.userSites
				.find(site => site.id == this.siteId)
				.channels
				.filter(channel => channel.is_supply == 1 || channel.is_self_production == 1)
				.map(channel => {
					return {
						value: channel.code,
						text: channel.name,
						is_supply: channel.is_supply,
						is_self_production: channel.is_self_production
					}
				})
		},
		supplyChannels() {
			return this.channels.filter(channel => channel.is_supply == 1)
		},
		selfProductionChannels() {
			return this.channels.filter(channel => channel.is_self_production == 1)
		}
	}
}
</script>
<style>
.err .month-year-display.input {
	border-color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/BillAudit/Modals/BillAuditModal.vue